export let forceSendMetrics = window.location.hash === '#forceSendMetrics';
export const setForceSendMetrics = (val) => {
    forceSendMetrics = val;
};
